module.exports = __webpack_public_path__ + "res/Roboto-BoldCondensed-webfontd41d.eot?127df9aa10d29f902fcc27af27f5b5a3";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldCondensed-webfontd41d.eot
// module id = 47
// module chunks = 0